
import { Base } from '../base-component';

import './header-banner-video.component.scss';
import { MediaQueryService } from '../../services/media-query.service';

export class HeaderBannerVideo extends Base {

	windowWidth: number;
	windowHeight: number;
	bannerRatio: number;
	playerRatio: number;

	banner: HTMLElement;
	header: HTMLElement;
	headerBackground: HTMLElement;
	imageHolder: HTMLElement;
	playerContainer:HTMLElement;
	playerContent:HTMLElement;
	player: any;
	video: any;
	playButton: HTMLElement;
	closeButton: HTMLElement;
	isExternal: boolean;

	constructor(element: Element){

		super(element);

		this.windowWidth = 1200;
		this.windowHeight = 365;
		this.bannerRatio = this.windowWidth / this.windowHeight;
		this.playerRatio = 854/480;

	}

	init() {
		this.banner = this.element as HTMLElement;
		this.header = this.element.querySelector('.header-banner-video__header') as HTMLElement;
		this.headerBackground = this.element.querySelector('.header-banner-video__header-background') as HTMLElement;
		this.imageHolder = this.element.querySelector('.header-banner-video__image-holder') as HTMLElement;
		this.playerContainer = this.element.querySelector('.header-banner-video__player-container') as HTMLElement;
		this.playerContent = this.element.querySelector('.header-banner-video__player-content') as HTMLElement;
		this.player = this.playerContainer.querySelector('.ot-video-containingBlock');
		this.video = this.element.querySelector('video');
		this.playButton = this.element.querySelector('.js-open-banner-video') as HTMLElement;
		this.closeButton = this.element.querySelector('.js-close-banner-video') as HTMLElement;
	}

	bindEvents() {

		window.addEventListener('resize', this.onResize.bind(this));
		window.addEventListener('orientationchange', this.onResize.bind(this));

		setTimeout(this.onResize.bind(this));
		setTimeout(this.checkVideoPlayer.bind(this), 200);

		this.playButton.addEventListener('click', this.showVideo.bind(this));
		this.closeButton.addEventListener('click', this.hideVideo.bind(this));

	}

	onResize() {

		this.banner.style.opacity = '1';

		this.setHeaderBackgroundDimensions();
		this.setVideoPlayerDimensions();

	}

	checkVideoPlayer() {

		if (this.player === null) {

			setTimeout(this.checkVideoPlayer.bind(this), 200);

		} else {

			this.playerContainer.style.opacity = '1';
			this.playerContainer.style.visibility = 'visible';
			this.playerContainer.style.display = 'none';

		}

	}

	showVideo(event) {

		if(event.currentTarget.hasAttribute('data-youtube-id')){

			this.isExternal = true;
			let videoExternal = event.currentTarget;
			this.element.classList.add('video-playing');
			let getVideo = videoExternal.getAttribute('data-youtube-id');
			this.createIframePlayer(getVideo);
			this.analyticsService.dtmVideoTrackerAutoSpot();

		}else{
		
			this.element.classList.add('video-playing');
			this.video.player.play();

		}
	}

	hideVideo(event) {
		event.preventDefault;

		let removeIframe = this.playerContent.querySelector('iframe');
		if(removeIframe){
			this.playerContent.removeChild(removeIframe); 
		}

		this.element.classList.remove('video-playing');
		this.video.player.pause();
	}

	setHeaderBackgroundDimensions() {
		this.headerBackground.style.height = `${this.header.clientHeight}px`;
	}

	setVideoPlayerDimensions() {

		if (MediaQueryService.getMediaQuery() !== 'small' && MediaQueryService.getMediaQuery() !== 'x-small') {

			let playerContainerHeight = this.windowWidth / this.bannerRatio;
			let playerContentWidth = playerContainerHeight * this.playerRatio;

			this.imageHolder.style.height = `${this.banner.clientHeight}px`;

			this.playerContainer.style.height = `${playerContainerHeight}px`;
			this.playerContent.style.maxWidth = `${playerContentWidth}px`;

		} else {

			let bannerHeight = this.imageHolder.querySelector("img").offsetHeight;

			let playerContainerHeight = bannerHeight + this.header.offsetHeight;
			let playerContentWidth = playerContainerHeight * this.playerRatio;

			this.imageHolder.style.height = `${bannerHeight}px`;

			this.playerContainer.style.height = `${playerContainerHeight}px`;
			this.playerContent.style.maxWidth = `${playerContentWidth}px`;

		}

	}

	createIframePlayer(url: any){

		this.playerContent.style.height = '100%';
		this.playerContainer.style.opacity = '1';
		this.playerContainer.style.visibility = 'visible';
		this.playerContainer.style.display = 'none';
		this.playerContainer.style.height = '100%';

		let externalUrl = 'https://www.youtube.com/embed/';
		externalUrl += url;
		externalUrl += '?rel=0&amp;showinfo=0&autoplay=1&enablejsapi=1';

		let createIframe = document.createElement('iframe');
		createIframe.id = 'video__external';
		createIframe.src = externalUrl;
		createIframe.classList.add('video__iframe');

		this.playerContent.appendChild(createIframe);
		this.analyticsService.dtmVideoTrackerAutoSpot();

	}

}



// WEBPACK FOOTER //
// ./components/header-banner-video/header-banner-video.component.ts